import { createRouter, createWebHistory  } from 'vue-router'
import Cookies from "js-cookie";
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';


const router = createRouter({
  history: createWebHistory(),
  routes:[
    {
      path: '/',
      name: 'login',
      component: () => import('@/login/login.vue')
    },
    { //主界面
      path: '/index',
      name: 'index',
      component: () => import('@/views/home/index.vue'),
      redirect: '/accountInfoManagement',
      children: [
        {
          path: '/accountInfoManagement',
          name: 'accountInfoManagement',
          component: () => import('@/views/accountInfoManagement/index.vue'),
          meta: { requiresUser: true }
        },
        {
          path: "accountInfoManagement/:id", // 项目详情路由
          name: "testInfoDetail",
          component: () => import("@/views/accountInfoManagement/components/detail.vue"),
          meta: { title: "检测详情" },
        },
        {
          path: '/testManagement',
          name: 'testManagement',
          component: () => import('@/views/testManagement/index.vue'),
          meta: { requiresUser: true }
        },
        {
          path: '/samplingTubeCodeManagement',
          name: 'samplingTubeCodeManagement',
          component: () => import('@/views/samplingTubeCodeManagement/index.vue'),
          meta: { requiresUser: true }
        },
        {
          path: "samplingTubeCodeManagement/:id", // 项目详情路由
          name: "samplingTubeCodeDetail",
          component: () => import("@/views/samplingTubeCodeManagement/components/detail.vue"),
          meta: { title: "样管详情" },
        },
        //代理商
        {
          path: '/agentManagement',
          name: 'agentManagement',
          component: () => import('@/views/agentManagement/index.vue'),
          meta: { requiresUser: true }
        },
        {
          path: '/nurseOrderManagement',
          name: 'nurseOrderManagement',
          component: () => import('@/views/nurseOrderManagement/index.vue'),
          meta: { requiresUser: true }
        },
        {
          path: '/suctomerService',
          name: 'suctomerService',
          component: () => import('@/views/customerService/index.vue'),
          meta: { requiresUser: true }
        },
        {
          path: '/reportManagement',
          name: 'reportManagement',
          component: () => import('@/views/reportManagement/index.vue'),
          meta: { requiresUser: true }
        },
        {
          path: '/nurseManagement',
          name: 'nurseManagement',
          component: () => import('@/views/nurseManagement/index.vue'),
          meta: { requiresUser: true }
        },
      ]
    },
  ]
})

router.beforeEach((to, from, next) => {
  NProgress.start();
  const tokenkey = Cookies.get('token');
  if (tokenkey) {
    next();
  } else{
    if(to.path == '/'){   //判断是否已经进入登录页面path  防止死循环
       next()
    }else{
      next('/')
    }
  }
});

router.afterEach((to,from,next)=>{
  NProgress.done()   //进度条结束
})



export default router
